import { useState } from "react";
import styled from "styled-components";
import { SuccessButton, WarningButton } from "../styles/button";
import { translate, Translate } from "../components/translate";
import { useLanguage } from "../stores/language_store";

export function RockPaperScissors() {
  const [userChoice, setUserChoice] = useState<string>();
  const [computerChoice, setComputerChoice] = useState<string>();
  const [result, setResult] = useState("");
  const [userScore, setUserScore] = useState(0);
  const [computerScore, setComputerScore] = useState(0);
  const language = useLanguage();

  const choices = ["rock", "paper", "scissors"];

  function rps(userSelection: string) {
    setUserChoice(userSelection);
    const randomChoice = choices[Math.floor(Math.random() * choices.length)];
    if (randomChoice !== undefined) {
      setComputerChoice(randomChoice);
      determineWinner(userSelection, randomChoice);
    }
  }

  function determineWinner(user: string, computer: string) {
    if (user === computer) {
      setResult(translate("tied", language));
    } else if (
      (user === "rock" && computer === "scissors") ||
      (user === "paper" && computer === "rock") ||
      (user === "scissors" && computer === "paper")
    ) {
      setResult(translate("win", language));
      setUserScore(userScore + 1);
    } else {
      setResult(translate("lose", language));
      setComputerScore(computerScore + 1);
    }
  }

  const resetGame = () => {
    setUserChoice(undefined);
    setComputerChoice(undefined);
    setResult("");
    setComputerScore(0);
    setUserScore(0);
  };

  return (
    <Container>
      <ButtonContainer>
        {choices.map((choice) => (
          <SuccessButton onClick={() => rps(choice)}>
            <Translate value={choice} />
          </SuccessButton>
        ))}
      </ButtonContainer>

      {userChoice ? (
        <ChoiceContainer>
          <p>
            <Translate value="user_choice" />
            <Translate value={userChoice} />
          </p>
          <p>
            <Translate value="computer_choice" />{" "}
            <Translate value={computerChoice ?? ""} />
          </p>
          <h2>{result}</h2>
          <ScoreContainer>
            <Score>
              <Translate value="user_result" /> {userScore}
            </Score>
            <Score>
              <Translate value="computer_result" /> {computerScore}
            </Score>
          </ScoreContainer>
        </ChoiceContainer>
      ) : (
        <></>
      )}

      <WarningButton onClick={() => resetGame()}>
        <Translate value="replay" />
      </WarningButton>
    </Container>
  );
}

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
`;

const Container = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: center;
`;

const ChoiceContainer = styled.div`
  gap: 0px;
  text-align: center;
`;

const ScoreContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
`;

const Score = styled.h3`
  background-color: aquamarine;
  border-radius: 5px;
  padding: 10px;
`;
